/**
 * 처리 단계 한 줄 — 점 세 개 옆에 '의도 파악 중…' 같은 문구를 **제자리에서 바꿔** 보여 준다(아래로 쌓지 않는다).
 *
 * - 서버가 그 일을 시작할 때 보낸 단계만 쓴다(`src/lib/chat-stages.ts`) — 시간에 맞춰 지어내지 않는다.
 * - 처음 STAGE_DELAY_MS 동안은 점만 — 바로 답하는 턴(인사·저장된 답)에 문구가 깜빡이지 않게.
 * - 한 문구는 최소 STAGE_MIN_MS — 그 사이 지나간 단계는 건너뛰고 **지금 단계**로 바로 간다(밀린 줄을 쌓지 않는다).
 * - 첫 글자가 오면 말풍선이 통째로 답으로 바뀌므로 따로 지우지 않는다. stop() 은 남은 타이머만 끈다.
 */
export const STAGE_DELAY_MS = 300;
export const STAGE_MIN_MS = 500;

export function createStageLine(target: HTMLElement, labelOf: (stage: string) => string | null) {
  const startedAt = Date.now();
  let shownAt = 0;
  let pending: string | null = null;
  let timer: ReturnType<typeof setTimeout> | null = null;
  let stopped = false;
  const el = document.createElement('span');
  el.className = 'cbsa-stage';
  const paint = () => {
    timer = null;
    if (stopped || pending == null) return;
    if (!el.isConnected) {
      const dots = target.querySelector('.cbsa-typing');
      if (!dots) return;               // 이미 답이 들어왔다
      dots.after(el);
    }
    // textContent 로만 쓴다 — HTML 로 해석하는 대입은 금지(CLAUDE.md §7-3). 이 설명을 코드 줄 꼬리에 두면
    // 보안 게이트가 위반으로 읽는다(꼬리 주석 속 진짜 위반을 놓치지 않으려고 일부러 그렇게 만들었다).
    el.textContent = `${pending}…`;
    shownAt = Date.now();
    pending = null;
  };
  return {
    push(stage: string) {
      const label = labelOf(stage);
      if (stopped || !label) return;
      pending = label;
      if (timer) return;               // 곧 그려진다 — 그때 최신 문구를 쓴다
      const now = Date.now();
      const wait = shownAt
        ? Math.max(0, STAGE_MIN_MS - (now - shownAt))
        : Math.max(0, STAGE_DELAY_MS - (now - startedAt));
      timer = setTimeout(paint, wait);
    },
    stop() { stopped = true; if (timer) clearTimeout(timer); },
  };
}
